import { NgModule } from '@angular/core';
import { DefaultCurrencyPipe } from './defaultCurrency-pipe';
import { CurrencyPipe } from '@angular/common';

@NgModule({
  declarations: [DefaultCurrencyPipe],
  imports: [],
  providers: [DefaultCurrencyPipe, CurrencyPipe],
  exports: [DefaultCurrencyPipe]
})
export class DefaultCurrencyPipeModule {
}

